import { Button } from '@/components'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import commonUtils from '@/utils/commonUtils'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

interface DataRow {
  rnum: number
  nttSn: number
  bbsTy: string
  lclasCd: string
  mlsfcCd: string
  bbsSj: string
  nttSj: string
  answerCnt: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  useYn: string
  replyYn: string
  daysPassed: number
}

const Component = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
`
const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`
const More = styled.span`
  font-size: 0.7rem;
  &:hover {
    cursor: pointer;
  }
`
const SubTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  color: #666;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
  justify-content: space-between;
`

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
`
const NoData = styled.div`
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid #ddd;
  font-size: 0.7rem;
  align-items: center;
`
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #ddd;
  font-size: 0.7rem;
  align-items: center;

  & > div {
    text-align: center;
    align-items: center;
  }

  & > div:nth-child(1) {
    flex: 2;
  }
  & > div:nth-child(2),
  & > div:nth-child(3) {
    flex: 3;
  }
  & > div:nth-child(4) {
    flex: 1;
  }
`
const MainBoard: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const { showAlert, showConfirm } = useDialog()
  const [totalCnt, setTotalCnt] = useState(0)
  const [checkList, setCheckList] = useState<DataRow[]>([])

  useEffect(() => {
    getCheckList()
  }, [])

  const getCheckList = async () => {
    const response = await axios.get('/inqrMgmt/checkList', {})
    if (response.status === 200) {
      setCheckList(response.data.data.checkList)
      setTotalCnt(response.data.data.checkList.length)
    } else {
      showAlert({
        type: 'error',
        message: '미답변 목록조회가 실패했어요.',
      })
    }
  }
  return (
    <Component>
      <Title>
        <h4>문의 미답변 리스트</h4>
        <More
          onClick={() => {
            navigate('/inqrMgmt')
          }}
        >
          더보기
        </More>
      </Title>

      {/* 부제목 */}
      <SubTitle>
        <span>접수된 문의 중 아직 답변이 등록되지 않은 항목이에요.</span>
        <span>총 {totalCnt} 건</span>
      </SubTitle>

      {/* 그리드 */}
      <Grid>
        <Row>
          <div>등록일</div>
          <div>제목</div>
          <div>대기일</div>
          <div></div>
        </Row>
        {checkList.length === 0 ? (
          <NoData>모든 문의에 답변을 완료했어요.</NoData>
        ) : (
          checkList.map((chk: DataRow, index) => (
            <Row key={index}>
              <div>
                {commonUtils.dateStrChgFomat(chk.regDate, 'yyyy.MM.dd')}
              </div>

              <div
                onClick={() => {
                  navigate('/inqrMgmt', {
                    state: {},
                  })
                }}
                style={{ cursor: 'pointer', textAlign: 'left' }}
              >
                {chk.nttSj}
              </div>
              <div>{chk.daysPassed}일</div>
              <div>
                <Button
                  color="neverbe"
                  variant="texted"
                  size="xs"
                  onClick={() => {
                    navigate('/inqrMgmt/detail', {
                      state: {
                        nttSn: chk.nttSn,
                      },
                    })
                  }}
                >
                  <span style={{ textDecoration: 'underline' }}>상세</span>
                </Button>
              </div>
            </Row>
          ))
        )}
      </Grid>
    </Component>
  )
}
export default MainBoard
